import { makeStyles } from "@material-ui/core";

export const useClearAllStyles = makeStyles(() => ({
  clearAll: {
    border: 0,
    margin: "0 10px 10px 0",
  },
}));
